import React, { FC } from 'react';
import KeywordsItem from './KeywordsItem';
import { IKeyword } from 'src/models/matchingProfiles/types';

interface IKeywordsAreaProps {
  keywords: readonly IKeyword[];
  disabled: boolean;
  mpId: string;
}

export const KeywordsPreview: FC<IKeywordsAreaProps> = props => {
  const { keywords, disabled, mpId } = props;

  return (
    <>
      {!!keywords.length &&
        keywords.map((keyword: IKeyword) => (
          <KeywordsItem mpId={mpId} keyword={keyword} key={keyword.id} disabled={disabled} />
        ))}
    </>
  );
};

export default KeywordsPreview;
